// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__i5Int","spin":"Loader_spin__N0pKB"};